/* eslint-disable no-undef */
import React, { useEffect, useState } from "react";
import FacebookOutlinedIcon from "@mui/icons-material/FacebookOutlined";
import XIcon from "@mui/icons-material/X";
import InstagramIcon from "@mui/icons-material/Instagram";
import YouTubeIcon from "@mui/icons-material/YouTube";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import CloseIcon from "@mui/icons-material/Close";
// import Select from "react-select";
import { Link, useNavigate } from "react-router-dom";
import PropTypes from "prop-types";
import MailOutlineIcon from "@mui/icons-material/MailOutline";
import CallIcon from "@mui/icons-material/Call";
import LocationCityIcon from "@mui/icons-material/LocationCity";

export default function Footers({ content }) {
  const [isclose, setIsClose] = useState(false);
  const chatTag = localStorage.getItem("toolTip");

  const router = useNavigate();


  const isMobile = () => {
    const maxWidth = 567;
    return window.innerWidth < maxWidth;
  };

  const handleScroll = () => {
    try {
      let number =
        window?.pageXOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop ||
        3;

      if (number >= 5) {
        if (window.innerWidth < 5) {
          document.getElementById("scol_oi")?.classList.remove("d-block");
          document.getElementById("scol_oi")?.classList.add("d-none");
        } else {
          document.getElementById("scol_oi")?.classList.add("d-block");
          document.getElementById("scol_oi")?.classList.remove("d-none");
        }
      } else {
        document.getElementById("scol_oi")?.classList.remove("d-block");
        document.getElementById("scol_oi")?.classList.add("d-none");
      }
    } catch (error) {
      // console.log("error", error.message);
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <React.Fragment>
      <footer className="foot_y">
        <div className="mx-lg-5 mx-3 position-relative">
          <div className="call_to mb-3 position-absolute  start-50 translate-middle-x w-100">
            <div className="container">
              <div className="pos_tile">
                <div className="row flex-md-row-reverse align-items-center justify-content-center text-start">
                  <div className="col-md-6 mb-sm-0 mb-3">
                    <div className="l">
                      <div className="h-100 d-flex justify-content-end">
                        <img
                          src={content?.img || "/assets/img/footer/c20.webp"}
                          className="im2"
                          loading="lazy"
                          // onError={(e) => e.currentTarget.src = '/assets/img/footer/c20.webp'}
                          alt="c20"
                        />
                      </div>
                    </div>
                  </div>

                  <div className="col-md-6 ">
                    <h1 className="mb-3">{content.title}</h1>
                    <p>{content.desc}</p>

                    <button
                      type="button"
                      onClick={() => router("/get-started")}
                      className="btn "
                    >
                      {content.btn}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          className="foot_u"
          style={{
            backgroundImage: "url(/assets/img/footer/BG.webp)",
            backgroundRepeat: "no-repeat",
            backgroundSize: "100%",
          }}
        >
          <img
            src="/assets/img/footer/logo.webp"
            className="res_img mt-sm-3 my-5"
            alt="logo"
            loading="lazy"
          />
        </div>

        <div className="footer_bg bg-white pt-0">
          <div className="container">
            <div className="row mb-2 text-start">
              <div className="col-lg-3">
                <div className="mb-3">
                  <h5>Products & Service</h5>
                </div>
                <nav className="foot-al34">
                  <ul className="foot-al2 ps-0">
                    <li>
                      <Link to="/restaurant-pos">Point of Sale</Link>
                    </li>
                    <li>
                      <Link to="/best-online-ordering">Online Store</Link>
                    </li>
                    <li>
                      <Link to="/self-serve-kiosks">Kiosk</Link>
                    </li>
                    <li>
                      <Link to="/kitchen-display">Kitchen Display</Link>
                    </li>
                    <li>
                      <Link to="/payments">Payment</Link>
                    </li>
                    <li>
                      <Link to="/cash-advance">Capital</Link>
                    </li>
                    <li>
                      <Link to="/inventory-management">Inventory</Link>
                    </li>
                  </ul>
                </nav>
              </div>
              <div className="col-lg-3">
                <div className="mb-3">
                  <h5>Business Types</h5>
                </div>
                <nav className="foot-al34">
                  <ul className="foot-al2 ps-0">
                    <li>
                      <Link to="/restaurant-overview">Food & Beverage</Link>
                    </li>
                    <li>
                      <Link to="/retail-pos">Retail</Link>
                    </li>
                    <li>
                      <Link to="/beauty">Beauty & Services</Link>
                    </li>
                  </ul>
                </nav>
              </div>
              <div className="col-lg-3">
                <div className="mb-3">
                  <h5>Resources</h5>
                </div>
                <nav className="foot-al34">
                  <ul className="foot-al2 ps-0">
                    <li>
                      <Link to="/pricing">Pricing</Link>
                    </li>
                    <li>
                      <Link to="/contact">Contact us</Link>
                    </li>
                    <li>
                      <Link to="/areas">Areas</Link>
                    </li>
                    <li>
                      <Link to="/help-and-support">Support</Link>
                    </li>
                    <li>
                      <Link to="/about-us">About us</Link>
                    </li>
                  </ul>
                </nav>
              </div>

              <div className="col-lg-3">
                <div className="mb-3">
                  <h5>CONNECT WITH US</h5>
                </div>
                <nav className="foot-al34">
                  <ul className="foot-al2 ps-0">
                    <li className="d-flex align-items-center gap-2">
                      <MailOutlineIcon fontSize="" />
                      <a
                        className="text-wrap"
                        href="mailto:sales@fusionmybusiness.com"
                      >
                        sales@fusionmybusiness.com
                      </a>
                    </li>
                    <li className="d-flex align-items-center gap-2">
                      <MailOutlineIcon fontSize="" />
                      <a
                        className="text-wrap"
                        href="mailto:reseller@fusionmybusiness.com"
                      >
                        reseller@fusionmybusiness.com
                      </a>
                    </li>
                    <li className="d-flex gap-2 align-items-center">
                      <CallIcon fontSize="" />
                      <a href="tel:02030263355" className="text-wrap">
                        UK: 0203 026 3355
                      </a>
                    </li>
                    <li className="d-flex  gap-2 align-items-center">
                      <CallIcon fontSize="" />
                      <a href="tel:353238804757" className="text-wrap">
                        IRE: +353 23 880 4757
                      </a>
                    </li>

                    <li className="d-flex  gap-2 align-items-start">
                      <LocationCityIcon fontSize="" />
                      <address className="text-wrap">
                        {" "}
                        IF 28, Threefield House, Threefield Ln, Southampton SO14
                        3LP
                      </address>
                    </li>
                  </ul>
                </nav>
              </div>
            </div>
            <div className="text-start"></div>
          </div>
        </div>

        <div className="border py-2 ">
          <div className="container">
            <div className="d-flex flex-wrap justify-content-between align-items-center gap-3">
              <div className="d-flex gap-3  flex-wrap play-ico">
                <div className="">
                  <a
                    href="https://apps.apple.com/in/app/fusion-my-business/id1502807167"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <img
                      loading="lazy"
                      src="/assets/img/google-play.webp"
                      className=""
                      alt=""
                    />
                  </a>
                </div>
                <div className="">
                  <a
                    href="https://play.google.com/store/apps/details?id=in.fusionpos.fusionpartner"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <img
                      loading="lazy"
                      src="/assets/img/apple-play.webp"
                      className=""
                      alt=""
                    />
                  </a>
                </div>
              </div>
              <div className="d-flex flex-wrap  gap-3">
                <a
                  href="https://www.facebook.com/FusionMyBusiness"
                  className="text-primary"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FacebookOutlinedIcon />
                </a>
                <a
                  href="https://x.com/fusionsmb"
                  target="_blank"
                  className="text-dark"
                  rel="noopener noreferrer"
                >
                  <XIcon />
                </a>
                <a
                  href="https://www.instagram.com/fusionmybusiness/"
                  target="_blank"
                  className="text-black"
                  rel="noopener noreferrer"
                >
                  <InstagramIcon />
                </a>
                <a
                  href="https://www.youtube.com/@FusionMyBusiness"
                  target="_blank"
                  className="text-danger"
                  rel="noopener noreferrer"
                >
                  <YouTubeIcon />
                </a>
                <a
                  href="https://www.linkedin.com/company/fusionmybusiness"
                  target="_blank"
                  className="text-primary"
                  rel="noopener noreferrer"
                >
                  <LinkedInIcon />
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="footer_bottom bg-white">
          <div className="container">
            <div className="row mt-4">
              <div className="col-lg-9 mb-3">
                <ul className="d-flex flex-wrap gap-4 foot-al2 ps-0">
                  <li>
                    <Link to="/terms-conditions">Terms </Link>
                  </li>
                  <li>
                    <Link to="/privacy">Privacy Policy</Link>
                  </li>
                  <li>
                    <Link to="/cookie-policy">Cookie Setting</Link>
                  </li>
                  <li>
                    <Link to="/delivery-terms-conditions">Delivery T&C</Link>
                  </li>
                </ul>
              </div>
              <div className="col-lg-3 mb-3"></div>
            </div>

            <p className="foot_te px-2">
              © 2025 | Fusion My Business Limited T/A Fusion My Business
            </p>
          </div>
        </div>
      </footer>
      {window.location.pathname != "/shop-catalogue" && (
        <div className="chat_toop">
          {chatTag == "open" ? (
            <div id="kp-opentool" className="toolTip card" role="button">
              <div className="card-body position-relative p-0">
                <div
                  role="button"
                  onClick={() => {
                    localStorage.setItem("toolTip", "clase");
                    document
                      .getElementById("kp-opentool")
                      ?.classList.add("d-none");
                  }}
                  className="clox-lk shadow"
                >
                  <CloseIcon className="text-black icon" fontSize="" />
                </div>
                <small
                  className="text-wrap"
                  onClick={() => {
                    document.getElementById("zsiq_float")?.click();
                    setIsClose(!isclose);
                  }}
                >
                  Hi there, welcome to Fusion. what brought you here today?
                </small>
              </div>
            </div>
          ) : (
            ""
          )}
          <div
            className="chat_i"
            // className="chat_i rise-shake"
            role="button"
            tabIndex={0}
            onClick={() => {
              document.getElementById("zsiq_float")?.click();
              setIsClose(!isclose);
            }}
            onKeyDown={(e) => {
              if (e.key === "Enter" || e.key === " ") {
                document.getElementById("zsiq_float")?.click();
                setIsClose(!isclose);
              }
            }}
          >
            {isMobile() ? (
              <img
                src="/assets/lchat.webp"
                className=""
                // style={{ width: "50px" }}
                alt=""
                loading="lazy"
              />
            ) : isclose ? (
              <div className="fd-hj">
                <CloseIcon className="text-white icon" />
              </div>
            ) : (
              <img
                src="/assets/lchat.webp"
                className=""
                // style={{ width: "50px" }}
                alt=""
                loading="lazy"
              />
            )}
          </div>
        </div>
      )}

      {window.location.pathname != "/delivery-payment" ? (
        <div
          id="scol_oi"
          className="d-none foot-shop shadow justify-content-between align-items-center d-flex gap-2 d-md-none "
        >
          <button
            type="button"
            onClick={() => router("/get-started")}
            className="btn w-100 btn-gd p-2"
          >
            Get Started
          </button>
          <button
            type="button"
            onClick={() => router("/contact")}
            className="btn w-100 btn-sn p-2"
          >
            Contact Sales
          </button>
        </div>
      ) : (
        ""
      )}
    </React.Fragment>
  );
}

Footers.propTypes = {
  content: PropTypes.object.isRequired,
};
